<script lang="ts" setup>
import { ParagraphFullHtmlText } from '~/api/graphql/generated'

defineProps<{
  entity: ParagraphFullHtmlText
}>()
</script>

<template>
  <Section>
    <TextSpecial class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1" :text="entity.fieldFullHtml?.processed" />
  </Section>
</template>
